import React from "react";
import { Truck, Home, Smartphone, Network, Boxes } from "lucide-react";

const services = [
  {
    title: "Bulk & Retail Supply",
    body: "High-volume bottled water for offices, events, hotels and retail outlets.",
    icon: Boxes,
    image:
      "https://images.pexels.com/photos/17806615/pexels-photo-17806615.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    title: "Home & Office Delivery",
    body: "Scheduled, on-demand delivery with verified purity.",
    icon: Home,
    span: "lg:col-span-5",
  },
  {
    title: "App-based Ordering",
    body: "Order, track, repeat — all from your phone.",
    icon: Smartphone,
    span: "lg:col-span-5",
  },
  {
    title: "Partner Distribution",
    body: "Dark store network extending coverage across Bengaluru and beyond.",
    icon: Network,
    image:
      "https://images.pexels.com/photos/6407532/pexels-photo-6407532.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-7",
  },
  {
    title: "Logistics & Supply Chain",
    body: "Route-optimized delivery, real-time fleet visibility.",
    icon: Truck,
    span: "lg:col-span-12",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32 water-grad">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow">Services</div>
            <h2 className="serif h-display mt-4 text-4xl sm:text-5xl lg:text-6xl text-[#0b1d2a]">
              Everything that moves water, <br />
              <span className="italic text-[#0369a1]">moves through us.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-slate-600">
            From single bottles at your door to fleet-scale distribution — Wateriia handles it end-to-end.
          </div>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-5">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={i}
                data-testid={`service-card-${i}`}
                className={`card-tilt relative overflow-hidden rounded-3xl bg-white border border-sky-100 p-7 md:p-8 ${s.span}`}
              >
                {s.image && (
                  <div className="rounded-2xl overflow-hidden mb-6 aspect-[16/9]">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="h-full w-full object-cover hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                )}
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="serif h-display text-2xl sm:text-3xl text-[#0b1d2a]">{s.title}</h3>
                    <p className="mt-3 text-slate-600 max-w-lg">{s.body}</p>
                  </div>
                  <div className="h-11 w-11 shrink-0 rounded-full bg-sky-50 border border-sky-100 flex items-center justify-center text-[#0369a1]">
                    <Icon size={18} />
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
